'use client';

import Script from 'next/script';
import React from 'react';
import colors from '../../styles/colors/index.module.scss';

export const LiveChat: React.FC = () => {
  if (!process.env.NEXT_PUBLIC_CHATRA_ID) return null;

  return (
    <Script
      id="chatra-script"
      strategy="afterInteractive"
    >
      {`
        (function(d, w, c) {
          window.ChatraSetup = {
            colors: {
              buttonText: '${colors.white}',
              buttonBg: '${colors.secondary}'
            }
          };
        })(document, window, 'Chatra');
      `}
      {`
        (function(d, w, c) {
            w.ChatraID = '${process.env.NEXT_PUBLIC_CHATRA_ID}';
            var s = d.createElement('script');
            w[c] = w[c] || function() {
                (w[c].q = w[c].q || []).push(arguments);
            };
            s.async = true;
            s.src = 'https://call.chatra.io/chatra.js';
            if (d.head) d.head.appendChild(s);
        })(document, window, 'Chatra');
      `}
    </Script>
  );
};
